export default __webpack_public_path__ + "static/media/2.4af69f8a.jpg";